import { render, staticRenderFns } from "./service.vue?vue&type=template&id=98191fd4&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"
import style0 from "./service.vue?vue&type=style&index=0&id=98191fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98191fd4",
  null
  
)

export default component.exports